import { Link } from "react-router-dom";
import logo from "../../../images/logo.png";

interface L33tProps {
  isBlock?: boolean;
}

const L33tComponent: React.FC<L33tProps> = (props) => {
  return (
    <div
      className={`${props.isBlock ? "d-none d-lg-block" : "mt-1 d-lg-none"}`}
    >
      {" "}
      <Link to='/home' className='navbar-brand m-0 p-0' title='Go to home page'>
        <div className='d-flex m-0 p-0'>
          <div>
            <img className='mb-1 pt-1' src={logo} alt='Lett' width={35} />
          </div>
          <div className='ms-2'>
            <p className='style-1 p-0 m-0'>L33T</p>
            <p className='style-2 p-0 m-0'>BY ENGISEEK</p>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default L33tComponent;
